import { render, staticRenderFns } from "./ModalPremiacaoMercado.vue?vue&type=template&id=56f0da18"
import script from "./ModalPremiacaoMercado.vue?vue&type=script&lang=js"
export * from "./ModalPremiacaoMercado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports